import gamedev1 from '../images/gamedev1.jpg';
import gamedev2 from '../images/gamedev2.jpg';
import gameadvisor from '../images/gameadvisor.jpg';
import Csadvisor from '../images/csadvisor.jpg';
import Csmentor from '../images/cs.jpg';
import Dsadvisor from '../images/Data Science - advisor.jpg';
import Dsmentor from '../images/Data Science.jpg';
import Uiadvisor from '../images/UI & UX Advisor.jpg';
import Uimentor from '../images/UI & UX Vice .jpg';
import uimentor2 from '../images/UI & UX.jpg';
import backadvisor from '../images/Back-End Advisor.jpg';
import backmentor from '../images/Back-End.jpg';
import frontmentor from '../images/Front-End.jpg';
import '../components/css components/technical.css';
import React, { useEffect } from 'react';
import WOW from 'wowjs';


function Technical(){
        useEffect(() => {
            const wow = new WOW.WOW({
            live: false
            });
            wow.init();
        }, []);
    return(
        <div className='technical' id='#board'>
            <h2 className='title'>Technical Board</h2>
            <div className='contain-board'>
                <div className='contain-tech'>
                    <img src={Csadvisor} alt='cs advisor' />
                    <img src={Csmentor} alt='cs mentor' />
                </div>
                <img src={gameadvisor} alt='game development advisor' />
                <img src={gamedev1} alt='game development mentor' />
                <img src={gamedev2} alt='game development mentor' />
                <div className='contain-tech'>
                    <img src={Dsadvisor} alt='ds advisor' />
                    <img src={Dsmentor} alt='ds mentor' />
                </div>
                <div className='contain-tech'>
                    <img src={uimentor2} alt='ui mentor' />
                    <img src={Uimentor} alt='ui mentor' />
                </div>
                <div className='contain-tech'>
                    <img src={frontmentor} alt='front end mentor' />
                    <img src={backmentor} alt='back end mentor' />
                </div>
                
            </div>
                {/* <h2 className='title'>Board 2023/2024</h2>
                <div className='top'>
                    <div className='card custom' id='vicel_1'>
                        <img src={viceleader2} alt='tst'/>
                        <h2>Rneem Tamer</h2>
                        <h3>Vice Leader</h3>
                    </div>
                    <div className='card' id='leader'>
                        <img src={mega} alt='tst'/>
                        <h2>Ahmed Ali</h2>
                        <h3>Team Leader</h3>
                    </div>
                    <div className='card custom' id='vicel_2'>
                        <img src={viceleader1} alt='tst'/>
                        <h2>Ahmed Magdy</h2>
                        <h3>Vice Leader</h3>
                    </div>

                </div>
                <div className='contain'>
                <div className='top'>
                    <div className='card custom' id='vicel_1'>
                        <img src={viceleader2} alt='tst'/>
                        <h2>Rneem Tamer</h2>
                        <h3>Vice Leader</h3>
                    </div>
                    <div className='card' id='leader'>
                        <img src={mega} alt='tst'/>
                        <h2>Ahmed Ali</h2>
                        <h3>Team Leader</h3>
                    </div>
                    <div className='card custom' id='vicel_2'>
                        <img src={viceleader1} alt='tst'/>
                        <h2>Ahmed Magdy</h2>
                        <h3>Vice Leader</h3>
                    </div>

                </div>
                <div className='top'>

                <div className='card custom' id='vicel_2'>
                        <img src={viceleader1} alt='tst'/>
                        <h2>Ahmed Magdy</h2>
                        <h3>Vice Leader</h3>
                    </div>
                    <div className='card custom' id='vicel_1'>
                        <img src={viceleader2} alt='tst'/>
                        <h2>Rneem Tamer</h2>
                        <h3>Vice Leader</h3>
                    </div>
                    <div className='card' id='leader'>
                        <img src={mega} alt='tst'/>
                        <h2>Ahmed Ali</h2>
                        <h3>Team Leader</h3>
                    </div>
                    
               

                </div> */}

                
                    {/* <div className='card'>
                        <img src={mega} alt='tst'/>
                        <h3>Team Leader</h3>
                    </div>
                    <div className='card'>
                        <img src={mega} alt='tst'/>
                        <h3>Team Leader</h3>
                    </div> */}
                {/* </div> */}
        </div>
    );
}

export default Technical;